<input
  [formControl]="control()"
  class="input-radio__radio-button absolute h-0 w-0 cursor-pointer opacity-0"
  [id]="radioButtonData().id"
  type="radio"
  [name]="radioButtonData().name"
  [value]="radioButtonData().value"
/>
<label
  class="mr:mr-0 relative mr-[9px] flex cursor-pointer select-none items-center text-[15px] font-normal not-italic leading-[10px]"
  [for]="radioButtonData().id"
  [title]="radioButtonData().title"
>
  {{ radioButtonData().label }}
</label>
